<template>
  <div class="container mt-4 contact-us-page">
    <!-- Top Section: Intro and Donation -->
    <div class="row">
      <!-- Left: Intro & Updates -->
      <div class="col-lg-8 mb-4">
        <div class="card shadow-sm h-100">
          <div class="card-header bg-primary text-white d-flex align-items-center">
            <h5 class="mb-0">关于自在量化</h5>
          </div>
          <div class="card-body">
            <div class="alert alert-light border-left-primary" role="alert">
              <h5 class="alert-heading">欢迎来到 自在量化!</h5>
              <p class="mb-0">我们的目标：量化市场一切，欢迎各位提出有效<a href="/feedback">建议</a>！</p>
            </div>
            
            <hr>
            <h6 class="font-weight-bold mb-3 border-bottom pb-2">更新日志</h6>
            <ul class="list-unstyled update-log">
              <li class="mb-3">
                <span class="badge badge-primary mr-2">2026.04.27</span>
                <span class="font-weight-bold">V3.1</span>：增加 <router-link to="/wonder/ai-report/morning" class="font-weight-bold">AI每日盘前</router-link> 与 <router-link to="/wonder/ai-report/evening" class="font-weight-bold">AI每日盘后</router-link> 挖掘当日题材爆发机会、深度复盘以及核心个股。
              </li>
              <li class="mb-3">
                <span class="badge badge-primary mr-2">2026.01.07</span>
                <span class="font-weight-bold">V3.0</span>：增加 <router-link to="/review/uplimit/lhb" class="font-weight-bold">龙虎榜复盘</router-link> 各种角度看龙虎榜游资大佬各显神通。
              </li>
              <li class="mb-3">
                <span class="badge badge-primary mr-2">2025.12.10</span>
                <span class="font-weight-bold">V2.4</span>：增加 <router-link to="/wonder/topic/table" class="font-weight-bold">题材表格</router-link> 题材推进以及对应概念和细分领域详情。
              </li>
              <li class="mb-3">
                <span class="badge badge-primary mr-2">2025.10.28</span>
                <span class="font-weight-bold">V2.3</span>：增加 <router-link to="/wonder/yjj/ml" class="font-weight-bold">题材推演</router-link> ，判断板块的持续性以及梯队核心。
              </li>
              <li class="mb-3">
                <span class="badge badge-primary mr-2">2025.05.31</span>
                <span class="font-weight-bold">V2.2</span>：情绪增加 <router-link to="/sentiment/cyclicality/vip" class="font-weight-bold">情绪周期VIP</router-link> ，明确周期节点，风险和机会一目了然。
              </li>
              <li class="mb-3">
                <span class="badge badge-primary mr-2">2025.05.27</span>
                <span class="font-weight-bold">V2.1</span>：复盘增加 <router-link to="/review/uplimit/progress" class="font-weight-bold">涨停推演</router-link> ，核心题材一目了然，推演配合模式。
              </li>
              <li class="mb-3">
                <span class="badge badge-secondary mr-2">2023.06.19</span>
                <span class="font-weight-bold">V2.0</span>：增加服务器优化速度，增加热点板块。
              </li>
              <li class="mb-3">
                <span class="badge badge-secondary mr-2">2021.02.21</span>
                <span class="font-weight-bold">V1.5</span>：各图增加最左拖动延伸数据以及标注月第一天和周一便于观察周期。
              </li>
              <li class="mb-3">
                <span class="badge badge-secondary mr-2">2021.01.21</span>
                <span class="font-weight-bold">V1.4</span>：新增情绪周期年度量化，什么时期玩大票，什么时期玩题材，什么时期观望。
              </li>
              <li class="mb-3">
                 <span class="badge badge-secondary mr-2">2020.09.10</span>
                 <span class="font-weight-bold">V1.3</span>：新增情绪分时、人气分时以及日K的人气和情绪，便于把握情绪节点。
              </li>
               <li class="mb-3">
                 <span class="badge badge-secondary mr-2">2020.08.09</span>
                 <span class="font-weight-bold">V1.2</span>：新增复盘模块的涨停梯队，以及K线、分时、板块、涨停原因(点击标的)，新增“复盘-涨停晋级”方便查看历史涨停晋级。
              </li>
               <li class="mb-3">
                 <span class="badge badge-secondary mr-2">2020.08.02</span>
                 <span class="font-weight-bold">V1.1</span>：新增主情绪日K图，人气日K图，在情绪周期模块，原情绪周期改为空间板。
              </li>
               <li class="mb-3">
                 <span class="badge badge-secondary mr-2">2020.07.26</span>
                 <span class="font-weight-bold">V1.0</span>：上线三个模块：情绪量化，涨停复盘，机器人常用功能说明。
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Right: Donation -->
      <div class="col-lg-4 mb-4">
        <div class="card shadow-sm h-100">
          <div class="card-header bg-danger text-white">
            <h5 class="mb-0">支持我们</h5>
          </div>
          <div class="card-body text-center d-flex flex-column justify-content-center">
            <div class="mb-4">
               <router-link to="/hall_of_fame" class="btn btn-outline-warning btn-sm shadow-sm font-weight-bold">
                  <b-icon icon="trophy" class="mr-1"></b-icon> <h5 class="text-danger font-weight-bold mb-0">荣誉殿堂 (捐赠墙)</h5>
               </router-link>
            </div>
            <p class="text-muted mb-4">感谢您的支持，捐赠将用于服务器费用</p>
            
            <div class="mb-4">
              <img class="img-fluid rounded border p-1 shadow-sm cursor-pointer" style="max-width: 180px;" :src="wxImg" alt="微信赞赏" @click="showImage(wxImg)">
              <div class="mt-2 small text-muted font-weight-bold">微信赞赏</div>
            </div>
            
            <div>
              <img class="img-fluid rounded border p-1 shadow-sm cursor-pointer" style="max-width: 150px;" :src="zfbImg" alt="支付宝捐赠" @click="showImage(zfbImg)">
              <div class="mt-2 small text-muted font-weight-bold">支付宝捐赠</div>
            </div>
            

          </div>
        </div>
      </div>
    </div>

    <!-- App Download Section -->
    <div class="row mb-3">
      <div class="col-12">
        <h5 class="pl-3 border-left border-primary text-primary font-weight-bold">客户端下载</h5>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <div class="card shadow-sm p-3 p-md-4 border-0 d-flex flex-md-row align-items-center justify-content-between app-download-banner">
          <div class="d-flex align-items-center mb-3 mb-md-0">
            <img :src="logoImg" style="width: 54px; height: 54px; border-radius: 12px;" class="mr-3 shadow-sm" alt="App Logo" />
            <div>
              <h5 class="font-weight-bold mb-1">自在量化 Android 客户端 (v1.2.0)</h5>
              <p class="text-muted small mb-0">随时随地看盘复盘 · 情绪监控 · 题材推演 · 极速暗黑模式</p>
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <router-link to="/download" class="btn btn-primary font-weight-bold mr-2 mb-1">
              <b-icon icon="phone" class="mr-1"></b-icon> 客户端下载与特性介绍
            </router-link>
            <a href="https://file.zizizaizai.com/quant/downloads/zzapp-release-latest.apk" download="zzapp-release-latest.apk" class="btn btn-outline-secondary font-weight-bold mb-1">
              <b-icon icon="cloud-arrow-down-fill" class="mr-1"></b-icon> 直接下载 APK
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Section -->
    <div class="row mb-3">
        <div class="col-12">
            <h5 class="pl-3 border-left border-primary text-primary font-weight-bold">联系方式</h5>
        </div>
    </div>
    
    <div class="row">
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm h-100 text-center p-3 contact-card">
          <div class="mb-3 img-container">
             <img class="img-fluid rounded" src="~assets/img/cjj3.jpg" alt="作者微信" />
          </div>
          <h6 class="font-weight-bold text-dark">作者微信</h6>
          <p class="text-muted small mb-0">加入讨论群请备注</p>
          <p class="text-muted small">老群有空位优先填上</p>
        </div>
      </div>

      <div class="col-md-4 mb-4">
        <div class="card shadow-sm h-100 text-center p-3 contact-card">
          <div class="mb-3 img-container">
            <img class="img-fluid rounded" src="~assets/img/zzquant.jpg" alt="公众号" />
          </div>
          <h6 class="font-weight-bold text-dark">微信公众号</h6>
          <p class="text-muted small mb-0">很随意的一些分享</p>
        </div>
      </div>

      <div class="col-md-4 mb-4">
        <div class="card shadow-sm h-100 text-center p-3 contact-card">
          <div class="mb-3 img-container">
            <img class="img-fluid rounded" src="~assets/img/cjj_hd.jpg" alt="视频号" />
          </div>
          <h6 class="font-weight-bold text-dark">微信视频号</h6>
          <p class="text-muted small mb-0">分享一些有价值的知识</p>
        </div>
      </div>
    </div>
    <!-- Image Preview Modal -->
    <b-modal id="img-preview-modal" hide-footer hide-header centered size="lg" body-class="p-0">
      <img :src="previewImage" class="img-fluid w-100" />
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  data() {
    return {
      logoImg: require('@/assets/img/logo.png'),
      wxImg: require('@/assets/img/jz_cjj_wx_jy.png'),
      zfbImg: require('@/assets/img/jz_cjj_zfb_jy.jpg'),
      previewImage: ''
    }
  },
  methods: {
    showImage(src) {
      this.previewImage = src
      this.$bvModal.show('img-preview-modal')
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.contact-us-page {
  max-width: 1200px;
}
.border-left-primary {
    border-left: 4px solid #007bff;
}
.update-log li {
    font-size: 0.95rem;
    line-height: 1.6;
}
.contact-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: none;
}
.contact-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
}
.img-container {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.img-container img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
}
.app-download-banner {
  background-color: var(--bg-card, #ffffff);
  border: 1px solid var(--border-color, #e2e8f0) !important;
}
body.theme-dark .app-download-banner,
.theme-dark .app-download-banner {
  background-color: var(--bg-card, #1e293b);
  border-color: var(--border-color, #334155) !important;
}
</style>
